// Translations for Arabic and English
export const translations = {
  en: {
    // Header
    tradingSignals: "Trading Signals",
    timeframe: "Timeframe",
    method: "Method",
    combined: "Combined (All)",
    showingSignals: "Showing signals based on",
    indicatorOnly: "indicator only",
    
    // Signals
    buy: "BUY",
    sell: "SELL",
    neutral: "NEUTRAL",
    hold: "HOLD",
    entry: "Entry",
    stopLoss: "Stop Loss",
    takeProfit: "Take Profit",
    support: "Support",
    resistance: "Resistance",
    current: "Current",
    confidence: "Confidence",
    risk: "Risk",
    strength: "Strength",
    strong: "STRONG",
    moderate: "MODERATE",
    weak: "WEAK",
    
    // Method names
    rsi: "RSI",
    macd: "MACD",
    bollinger: "Bollinger Bands",
    stochastic: "Stochastic",
    movingAverages: "Moving Averages",
    adx: "ADX (Trend)",
    williamsR: "Williams %R",
    supportResistance: "Support/Resistance",
    
    // Tabs
    chart: "Chart",
    signals: "Signals",
    alerts: "Alerts",
    training: "Training",
    
    // Paper Trading
    paperTrading: "Paper Trading",
    
    // Admin
    adminPanel: "Admin Panel",
    logout: "Logout",
    
    // Misc
    livePrice: "Live Price",
    loading: "Loading...",
    noDataAvailable: "No data available",
    doesNotSuggest: "does not suggest",
    currentSignal: "Current signal",
    noAccessSignals: "You do not have access to trading signals. Contact admin to upgrade your account.",
    
    // Analyze
    analyze: "Analyze",
    selectMarketPrompt: "Select Market & Timeframe",
    selectMarketDesc: "Choose your market, timeframe, and analysis method, then click Analyze to get live signals.",
    
    // Language
    language: "Language",
    english: "English",
    arabic: "العربية",
  },
  
  ar: {
    // Header
    tradingSignals: "إشارات التداول",
    timeframe: "الإطار الزمني",
    method: "الطريقة",
    combined: "مجمع (الكل)",
    showingSignals: "عرض الإشارات بناءً على",
    indicatorOnly: "فقط",
    
    // Signals
    buy: "شراء",
    sell: "بيع",
    neutral: "محايد",
    hold: "انتظار",
    entry: "نقطة الدخول",
    stopLoss: "وقف الخسارة",
    takeProfit: "هدف الربح",
    support: "الدعم",
    resistance: "المقاومة",
    current: "الحالي",
    confidence: "الثقة",
    risk: "المخاطرة",
    strength: "القوة",
    strong: "قوي",
    moderate: "متوسط",
    weak: "ضعيف",
    
    // Method names
    rsi: "مؤشر القوة النسبية RSI",
    macd: "مؤشر MACD",
    bollinger: "نطاقات بولينجر",
    stochastic: "ستوكاستيك",
    movingAverages: "المتوسطات المتحركة",
    adx: "قوة الاتجاه ADX",
    williamsR: "ويليامز %R",
    supportResistance: "الدعوم والمقاومات",
    
    // Tabs
    chart: "الرسم البياني",
    signals: "الإشارات",
    alerts: "التنبيهات",
    training: "التدريب",
    
    // Paper Trading
    paperTrading: "التداول الورقي",
    
    // Admin
    adminPanel: "لوحة الإدارة",
    logout: "تسجيل خروج",
    
    // Misc
    livePrice: "السعر المباشر",
    loading: "جاري التحميل...",
    noDataAvailable: "لا توجد بيانات متاحة",
    doesNotSuggest: "لا يقترح",
    currentSignal: "الإشارة الحالية",
    noAccessSignals: "ليس لديك صلاحية للوصول إلى الإشارات. تواصل مع المدير لترقية حسابك.",
    
    // Analyze
    analyze: "تحليل",
    selectMarketPrompt: "اختر السوق والإطار الزمني",
    selectMarketDesc: "اختر السوق والإطار الزمني وطريقة التحليل، ثم اضغط تحليل للحصول على الإشارات.",
    
    // Language
    language: "اللغة",
    english: "English",
    arabic: "العربية",
  }
};

// Re-export flash cards data from separate file
export { FLASH_CARDS_DATA, SIGNAL_METHODS } from './data/flashCardsData';
